// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  background-color: #333;
  display: flex;
  justify-content: center; 
  align-items: center; 
  position: relative;
  z-index: 10;  /* ensure this is above any other z-index in your layout */
}

nav {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%; 
}

nav ul {
  list-style: none;
  margin: 0;
  padding: 10px;
  display: flex;
  justify-content: center; 
  width: 100%; 
  top: 100%;  /* positions the list right below the nav bar */
  right: 0;   /* pushes the list to the far right */
  text-align: right;
}

nav li {
  margin: 0 15px; 
}

nav a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s;
}

nav a:hover,
nav a.active {
  color: #00a8ff;
}

.menu-icon {
  display: none; 
  cursor: pointer;
  color: #fff;
  font-size: 32px;
  margin-left: auto; 
}

.nav-list {
  right: 0;  /* This will position the list to the right */
}

.nav-list.open {
  display: flex;
}

@media (max-width: 768px) {
  .menu-icon {
    display: block;
  }

  nav ul {
    display: none; 
    flex-direction: column;
    position: absolute;
    right: 10px;
    background-color: #333;
  }

  nav li {
    margin: 10px 0;
  }

  .nav-list.open {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW,GAAG,0DAA0D;AAC1E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAS,GAAG,+CAA+C;EAC3D,QAAQ,IAAI,qCAAqC;EACjD,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ,GAAG,6CAA6C;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["header {\n  background-color: #333;\n  display: flex;\n  justify-content: center; \n  align-items: center; \n  position: relative;\n  z-index: 10;  /* ensure this is above any other z-index in your layout */\n}\n\nnav {\n  display: flex;\n  justify-content: space-between; \n  align-items: center;\n  width: 100%; \n}\n\nnav ul {\n  list-style: none;\n  margin: 0;\n  padding: 10px;\n  display: flex;\n  justify-content: center; \n  width: 100%; \n  top: 100%;  /* positions the list right below the nav bar */\n  right: 0;   /* pushes the list to the far right */\n  text-align: right;\n}\n\nnav li {\n  margin: 0 15px; \n}\n\nnav a {\n  color: #fff;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\nnav a:hover,\nnav a.active {\n  color: #00a8ff;\n}\n\n.menu-icon {\n  display: none; \n  cursor: pointer;\n  color: #fff;\n  font-size: 32px;\n  margin-left: auto; \n}\n\n.nav-list {\n  right: 0;  /* This will position the list to the right */\n}\n\n.nav-list.open {\n  display: flex;\n}\n\n@media (max-width: 768px) {\n  .menu-icon {\n    display: block;\n  }\n\n  nav ul {\n    display: none; \n    flex-direction: column;\n    position: absolute;\n    right: 10px;\n    background-color: #333;\n  }\n\n  nav li {\n    margin: 10px 0;\n  }\n\n  .nav-list.open {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
